import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Window from 'helpers/window'

import { screenSize } from 'styles/shared'

type Props = {
  onClickCallback: (label: string) => void
}

const BackToTopButton = ({ onClickCallback }: Props) => {
  const yVisibleThreshold = 400

  const [showButton, setShowButton] = useState(window.scrollY > yVisibleThreshold)

  useEffect(() => {
    const listener = () => {
      if (window.scrollY > yVisibleThreshold) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    }

    window.addEventListener('scroll', listener)

    return () => window.removeEventListener('scroll', listener)
  }, [])

  const onBackToTopButtonClick = () => {
    Window.scrollTo({ top: 0 })
    onClickCallback('Back to Top')
  }

  return (
    <S.Container>
      <S.ButtonContainer>
        <Button
          decoration="positive"
          onPress={onBackToTopButtonClick}
          styles={{ button: { opacity: showButton ? 1 : 0, height: 26, borderRadius: 15 } }}
          text="Back to Top"
          aria-label="back-to-top"
        />
      </S.ButtonContainer>
    </S.Container>
  )
}

export default BackToTopButton

const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
  `,
  ButtonContainer: styled.div`
    position: fixed;
    top: 50px;
    z-index: 99;
    height: 26px;
    padding: 5px 13px;

    border-radius: 1rem;

    @media (${screenSize.small}) {
      top: 60px;
    }
  `
}
